/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Allocation_UserInputs */

const cs_billing_allocation_user = /** @type {(inputs: Billing_Allocation_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel`)
};

const en_billing_allocation_user = /** @type {(inputs: Billing_Allocation_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Billing_Allocation_UserInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_allocation_user = /** @type {((inputs?: Billing_Allocation_UserInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Allocation_UserInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_allocation_user(inputs)
	return cs_billing_allocation_user(inputs)
});